/**
 * Acts like Ruby Hash's dig method, digging into a nested object, returning either the final result or null
 */
// eslint-disable-next-line import/prefer-default-export
export function dig(obj, ...fields) {
  return fields.reduce((scope, key) => (scope && scope[key] ? scope[key] : null), obj);
}
